module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "project-update-assignement"
  }, [_c('div', {
    staticClass: "grid-2 has-gutter-xl"
  }, [_c('div', [_c('form', {
    staticClass: "assign_user",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.assignUser($event)
      }
    }
  }, [_c('field', {
    directives: [{
      name: "can",
      rawName: "v-can",
      value: ('projects.options'),
      expression: "'projects.options'"
    }],
    attrs: {
      "type": "select",
      "collection": _vm.users,
      "model": "project",
      "name": "user_to_assign",
      "params": {
        no_i18n: true
      }
    },
    model: {
      value: (_vm.user_to_assign),
      callback: function($$v) {
        _vm.user_to_assign = $$v
      },
      expression: "user_to_assign"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v(_vm._s(_vm.$t('ui.pages.project-assign')))])])], 1), _vm._v(" "), _c('collection', {
    directives: [{
      name: "can",
      rawName: "v-can",
      value: ('projects.options'),
      expression: "'projects.options'"
    }],
    attrs: {
      "data": _vm.assigned_users,
      "structure": _vm.user_structure,
      "model": "user"
    },
    on: {
      "itemDelete": _vm.unassignUser
    }
  })], 1), _vm._v(" "), _c('div', [_c('form', {
    staticClass: "assign_businesskit",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.assignBusinesskit($event)
      }
    }
  }, [_c('field', {
    directives: [{
      name: "can",
      rawName: "v-can",
      value: ('projects.options'),
      expression: "'projects.options'"
    }],
    attrs: {
      "type": "select",
      "collection": _vm.businesskits,
      "model": "project",
      "name": "businesskit_to_assign",
      "params": {
        no_i18n: true
      }
    },
    model: {
      value: (_vm.businesskit_to_assign),
      callback: function($$v) {
        _vm.businesskit_to_assign = $$v
      },
      expression: "businesskit_to_assign"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v(_vm._s(_vm.$t('ui.pages.project-assign')))])])], 1), _vm._v(" "), _c('collection', {
    directives: [{
      name: "can",
      rawName: "v-can",
      value: ('projects.options'),
      expression: "'projects.options'"
    }],
    attrs: {
      "data": _vm.assigned_businesskits,
      "structure": _vm.businesskit_structure,
      "model": "business_kit"
    },
    on: {
      "itemDelete": _vm.unassignBusinesskit
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "update-form--actions"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit",
      "data-action": "project.update"
    },
    on: {
      "click": function($event) {
        return _vm.finish()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('ui.pages.project-' + _vm.type + '-button')))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e47472b0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/projects/ProjectUpdateAssignement.vue
// module id = 2005
// module chunks = 0